/**
 * PR23 owner follow-up: one accessible collapse/expand button per information
 * panel.
 *
 * Collapse is presentation only. Callers keep every stateful editing control
 * mounted and hide the panel body with the `hidden` attribute, matching the
 * existing team-groups toggle. The explicit Enter/Space handling mirrors that
 * control and keeps focus on the same button while the panel opens or closes.
 */
export function OpportunityPanelToggle({
  controls,
  expanded,
  label,
  testId,
  onToggle,
}: {
  controls: string;
  expanded: boolean;
  label: string;
  testId: string;
  onToggle: () => void;
}) {
  return (
    <button
      type="button"
      className="shrink-0 rounded border border-border px-3 py-2 text-sm"
      data-testid={testId}
      aria-expanded={expanded}
      aria-controls={controls}
      aria-label={`${expanded ? "Sažmi" : "Proširi"} ${label}`}
      onClick={onToggle}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          // Activate explicitly so the toggle is keyboard-testable and does not
          // also fire a native button click from the same key press.
          event.preventDefault();
          onToggle();
        }
      }}
    >
      {expanded ? "Sažmi" : "Proširi"}
    </button>
  );
}
